export const PAYMENTS_ROUTE_NAMES = {
    LIST: "PaymentsList",
};
